import { zoomOptions } from "./zoomOptions";

export const defaultGrace = '10%';

export const defaultOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      zoom: {...zoomOptions},
      legend: {
        display: true,
      },
      annotation: {
        annotations: {
          //annotation
        }
      }
    },
    scales: {
      y: {
        afterFit(scale) {
          const max = Math.max(...scale.ticks.map(o => o.value))
          const min = Math.min(...scale.ticks.map(o => o.value))
          const digits = Math.max(getNumberOfDigits(max),getNumberOfDigits(min));
          scale.width = scale.width+digits*4;
        },
        grace: '10%',
        ticks: {
          display: true,
          autoSkip: true
          //stepSize: 5,
        },
        grid: {
          display: true,
          drawBorder: false,
          drawOnChartArea: true,
          drawTicks: false,
        },
  
      },
      y1: {
        grace: '10%',
        ticks: {
          display: false,
          //stepSize: 5,
        },
        grid: {
          display: false,
          drawBorder: false,
          drawOnChartArea: true,
          drawTicks: false,
        },
        border: {
          display: false
        }
      },
      y2: {
        grace: '10%',
        ticks: {
          display: false,
          //stepSize: 5,
        },
        grid: {
          display: false,
          drawBorder: false,
          drawOnChartArea: true,
          drawTicks: false,
        },
        border: {
          display: false
        }
      },
      y3: {
        grace: '10%',
        ticks: {
          display: false,
          //stepSize: 5,
        },
        grid: {
          display: false,
          drawBorder: false,
          drawOnChartArea: true,
          drawTicks: false,
        },
        border: {
          display: false
        }
      },
      y4: {
        grace: '10%',
        ticks: {
          display: false,
          //stepSize: 5,
        },
        grid: {
          display: false,
          drawBorder: false,
          drawOnChartArea: true,
          drawTicks: false,
        },
        border: {
          display: false
        }
      },
      y5: {
        grace: '10%',
        ticks: {
          display: false,
          //stepSize: 5,
        },
        grid: {
          display: false,
          drawBorder: false,
          drawOnChartArea: true,
          drawTicks: false,
        },
        border: {
          display: false
        }
      },
      y6: {
        grace: '10%',
        ticks: {
          display: false,
          //stepSize: 5,
        },
        grid: {
          display: false,
          drawBorder: false,
          drawOnChartArea: true,
          drawTicks: false,
        },
        border: {
          display: false
        }
      },
      y7: {
        grace: '10%',
        ticks: {
          display: false,
          //stepSize: 5,
        },
        grid: {
          display: false,
          drawBorder: false,
          drawOnChartArea: true,
          drawTicks: false,
        },
        border: {
          display: false
        }
      },
      y8: {
        grace: '10%',
        ticks: {
          display: false,
          //stepSize: 5,
        },
        grid: {
          display: false,
          drawBorder: false,
          drawOnChartArea: true,
          drawTicks: false,
        },
        border: {
          display: false
        }
      },
      x: {
        parsing: false,
        type: 'time',
        time: {
          displayFormats: {
            hour: 'hh:mm',
            minute: 'hh:mm',
          }
        },
        ticks: {
          display: true,
          autoSkip: true,
          maxRotation: 0,
          //maxTicksLimit: 5,
          //padding: 10,
          align: 'start',
          major: {
            enabled: true
          },
        },
        grid: {
          display: false,
          drawBorder: false,
          drawOnChartArea: false,
          drawTicks: true,
        }
      }
    }
  
  };
  
  

  const getNumberOfDigits = (number: Number) => {
    return number.toString().length;
}